import React, { useState, useEffect } from "react";

import useForm from "../../shared/useForm";
import { ApiUnit } from "../../unit/ApiUnit";
import "react-datepicker/dist/react-datepicker.css";
import "./VacantResponsibilitiesReport.css";
import { saveAs } from "file-saver";

import {
  GetLanguageString,
  NoResult,
  SetReportTitle,
} from "../../helper/Components";
import {
  LoadingSpinner,
  applyClassToCharacters,
} from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { ApiResponsibility } from "../../config/responsibilityType/ApiResponsibilityType";
import swal from "sweetalert";
import { FcPrint } from "react-icons/fc";
import { RiFileExcel2Line } from "react-icons/ri";
import {
  ReportActionButton,
  ReportFilterCard,
  ReportSection,
  ReportSwitch,
  ScopeSegments,
  UnitSelects,
} from "../shared/ReportKit";

// every string that comes from the backend goes through this
const ur = (value) => applyClassToCharacters(value, "ur");

const MANY_VACANT = 10;

const SCOPES = [
  {
    key: "None",
    label: "report_member_show_all_units",
    units: ["Markaz", "Zone", "Halqa"],
  },
  { key: "Zone", label: "report_member_show_zones", units: ["Markaz"] },
  {
    key: "Halqa",
    label: "report_member_show_halqa",
    units: ["Markaz", "Zone"],
  },
  {
    key: "Tanzeem",
    label: "report_member_show_tanzeem",
    units: ["Markaz", "Zone", "Halqa"],
  },
  {
    key: "Usra",
    label: "report_member_show_usra",
    units: ["Markaz", "Zone", "Halqa"],
  },
];

const Crumbs = ({ unitName }) => (
  <span className="vr-crumbs">
    {unitName?.split("،")?.map((part, i) => (
      <span key={i} className="vr-crumb">
        {ur(part)}
      </span>
    ))}
  </span>
);

const MemberTable = ({ members, showNote }) => {
  if (!members || members.length === 0) {
    return <NoResult />;
  }

  return (
    <div className="rk-scroll">
      <table className="rk-table vr-members">
        <thead>
          <tr>
            <th>#</th>
            <th>
              <GetLanguageString props="member_reg_number" />
            </th>
            <th>
              <GetLanguageString props="common_name" />
            </th>
            <th>
              <GetLanguageString props="member_father_name" />
            </th>
            <th>
              <GetLanguageString props="member_responsibility" />
            </th>
            <th>
              <GetLanguageString props="member_member_detail_common_unit_name" />
            </th>
            {showNote && (
              <th>
                <GetLanguageString props="report_vacant_responsibilities_exemption_letter_no" />
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {members.map((record, index) =>
            record.responsibilities.map((item, index1) => {
              const span = record.responsibilities.length;
              return (
                <tr key={`${index}-${index1}`}>
                  {index1 === 0 && (
                    <>
                      <td rowSpan={span} className="vr-num">
                        {index + 1}
                      </td>
                      <td rowSpan={span} className="vr-reg">
                        {ur(record.regNo)}
                      </td>
                      <td rowSpan={span} className="ur vr-name">
                        {ur(record.name)}
                      </td>
                      <td rowSpan={span} className="ur">
                        {ur(record.fatherName)}
                      </td>
                    </>
                  )}
                  <td className="ur">
                    <span className="vr-role">
                      {ur(item.responsibilityName)}
                    </span>
                  </td>
                  <td className="ur">
                    <Crumbs unitName={item.unitName} />
                  </td>
                  {showNote && (
                    <td className="ur">
                      {item.referenceNote ? (
                        <span className="vr-note">
                          {ur(item.referenceNote)}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>
                  )}
                </tr>
              );
            }),
          )}
        </tbody>
      </table>
    </div>
  );
};

const STAT_TONES = ["assigned", "vacant", "dual", "triple", "mubtadi"];

const VacantResponsibilitiesReport = () => {
  const [loading, setLoading] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [reportTitle, setReportTitle] = useState("");
  const [modal, setModal] = useState(false);
  const [searchButton, setSearchButton] = useState(false);
  const [searchValue, setSearchValue] = useState({
    unitId: loggedInUnitId,
    showDetails: true,
    showSelectedUnitsCheck: "None",
    showSemiRequired: true,
  });
  const unitTypeName = "null";
  let totalCount = {
    vacantResponsibilities: 0,
    totalResponsibilities: 0,
    twoResponsibles: 0,
    threeResponsibiles: 0,
    mubatadiResponsibiles: 0,
  };

  const [unitList, setUnitList] = useState([]);
  const [responsibilitiesList, setResponsibilitiesList] = useState([]);
  const { values, setValues } = useForm(searchValue);
  const [reportData, setReportData] = useState();
  const [unitType, setUnitType] = useState(
    encryptStorage.getItem("unitTypeName"),
  );

  useEffect(() => {
    ApiUnit()
      .getUnitList(loggedInUnitId, loggedInUnitId, false, unitTypeName, true)
      .then((res) => {
        setUnitList(res.data);
      })
      .catch((err) => console.log(err));
  }, [loggedInUnitId]);

  const handleChangeUnits = (record) => {
    if (record !== null) {
      ApiUnit()
        .getUnitList(record.value, loggedInUnitId, false, unitTypeName, true)
        .then((res) => {
          setUnitList(res.data);
        })
        .catch((err) => console.log(err));
      setValues({
        ...values,
        unitId: record.value,
        showSelectedUnitsCheck: "None",
      });
      setUnitType(record.label1);
    } else {
      ApiUnit()
        .getUnitList(loggedInUnitId, loggedInUnitId, false, unitTypeName, true)
        .then((res) => {
          setUnitList(res.data);
        })
        .catch((err) => console.log(err));
      setValues({
        ...values,
        unitId: 0,
      });
    }
  };

  const handleToggle = (name) => {
    setValues({ ...values, [name]: !values[name] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSearchButton(true);
    setSearchValue(values);
  };

  const handleScope = (key) => {
    setValues({ ...values, showSelectedUnitsCheck: key });
  };

  useEffect(() => {
    if (searchValue && searchButton) {
      setLoading(true);
      ApiResponsibility()
        .GetVacantResponsibilitiesReport(
          searchValue.unitId,
          searchValue.showDetails,
          searchValue.showSemiRequired,
          searchValue.showSelectedUnitsCheck,
        )
        .then((res) => {
          setReportData(res.data);
          setResponsibilitiesList(res.data.responsibilities);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          swal({
            title: err,
            icon: "error",
            buttons: "OK",
          });
        });
    }
  }, [searchValue, searchButton]);

  useEffect(() => {
    if (reportTitle !== "") window.print();
  }, [reportTitle]);

  const handleReportTitle = () => {
    setModal(true);
  };

  const excelDownload = () => {
    if (searchValue && searchButton) {
      setExcelLoading(true);
      ApiResponsibility()
        .GetVacantResponsibilitiesExcelReport(
          searchValue.unitId,
          searchValue.showDetails,
          searchValue.showSemiRequired,
          searchValue.showSelectedUnitsCheck,
        )
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "ResponsibilitiesOverviewReport.xlsx");
        })
        .catch((err) => {
          console.log(err);
          swal({
            title: err,
            icon: "error",
            buttons: "OK",
          });
        })
        .finally(() => setExcelLoading(false));
    }
  };

  const assignedPercent = reportData?.totalResponsibilitiesCount
    ? Math.round(
        (reportData.assignedResponsibilitiesCount /
          reportData.totalResponsibilitiesCount) *
          100,
      )
    : 0;

  const stats = [
    {
      value: reportData?.assignedResponsibilitiesCount,
      label: "report_vacant_responsibilities_assigned",
    },
    {
      value: reportData?.vacantResponsibilitiesCount,
      label: "report_vacant_responsibilities_vacant",
    },
    {
      value: reportData?.twoResponsibleMembersCount,
      label: "report_vacant_responsibilities_two_responsibles",
    },
    {
      value: reportData?.threeResponsibleMembersCount,
      label: "report_vacant_responsibilities_three_responsibles",
    },
    {
      value: reportData?.mubtadiResponsibleMembersCount,
      label: "report_vacant_responsibilities_mubtadi_responsibles",
    },
  ];

  const unitResponsibilityItems = reportData?.unitResponsibiities ?? [];

  return (
    <div>
      {modal ? (
        <SetReportTitle setModal={setModal} setReportTitle={setReportTitle} />
      ) : null}
      <div className="wrapper-custom wrapper wrapper-content animated fadeInRight rk-page vr-page">
        <ReportFilterCard
          title={<GetLanguageString props="common_generate_report" />}
          onSubmit={handleSubmit}
          submitLabel={<GetLanguageString props="common_view_report" />}
        >
          <UnitSelects unitList={unitList} onChange={handleChangeUnits} />

          <div className="rk-switches">
            <ReportSwitch
              checked={values.showDetails}
              onChange={() => handleToggle("showDetails")}
              label={
                <GetLanguageString props="report_vacant_responsibilities_show_details" />
              }
            />
            <ReportSwitch
              checked={!values.showSemiRequired}
              onChange={() => handleToggle("showSemiRequired")}
              label={
                <GetLanguageString props="report_vacant_responsibilities_show_semi_required_responsibilities" />
              }
            />
          </div>

          <ScopeSegments
            scopes={SCOPES.filter((scope) =>
              scope.units.includes(unitType),
            ).map((scope) => ({
              key: scope.key,
              label: <GetLanguageString props={scope.label} />,
            }))}
            value={values.showSelectedUnitsCheck}
            onChange={handleScope}
          />
        </ReportFilterCard>

        {!loading ? (
          searchButton && reportData !== undefined ? (
            <div id="section-to-print">
              <div className="print text-center">
                <h3>Title : {reportTitle}</h3>
              </div>

              <div className="vr-titlebar">
                <div className="vr-titlebar-text">
                  <h3>
                    <GetLanguageString props="report_vacant_responsibilities_title" />
                  </h3>
                </div>
                <div className="vr-actions noprint">
                  <ReportActionButton
                    onClick={excelDownload}
                    loading={excelLoading}
                    icon={<RiFileExcel2Line size={16} color="#009440" />}
                    label={
                      <GetLanguageString props="member_report_export_excel" />
                    }
                  />
                  <ReportActionButton
                    onClick={handleReportTitle}
                    icon={<FcPrint size={16} />}
                    label={<GetLanguageString props="common_print" />}
                  />
                </div>
              </div>

              <div className="vr-hero">
                <div className="vr-hero-title">
                  <h1 className="ur">{ur(reportData?.unitName)}</h1>
                  <h3>
                    <GetLanguageString props="report_vacant_responsibilities_total" />{" "}
                    : {reportData?.totalResponsibilitiesCount}
                  </h3>
                  <div className="vr-bar">
                    <i style={{ width: `${assignedPercent}%` }} />
                  </div>
                  <small>
                    {reportData?.assignedResponsibilitiesCount} /{" "}
                    {reportData?.totalResponsibilitiesCount}{" "}
                    <GetLanguageString props="report_vacant_responsibilities_assigned" />{" "}
                    ({assignedPercent}%)
                  </small>
                </div>
              </div>

              <div className="vr-stats">
                {stats.map((stat, i) => (
                  <div
                    key={stat.label}
                    className={`vr-stat vr-stat-${STAT_TONES[i]}`}
                    style={{ animationDelay: `${0.05 * (i + 1)}s` }}
                  >
                    <strong>{stat.value}</strong>
                    <span>
                      <GetLanguageString props={stat.label} />
                    </span>
                  </div>
                ))}
              </div>

              {reportData?.unitResponsibilitiesCounts !== null &&
              unitResponsibilityItems.length > 0 ? (
                <ReportSection
                  title={
                    <GetLanguageString props="report_vacant_responsibilities_unit_responsibilities" />
                  }
                >
                  <div className="vr-resp-grid">
                    {unitResponsibilityItems.map((item, index) => {
                      const count = Object.values(
                        reportData.unitResponsibilitiesCounts,
                      )[index];
                      return (
                        <div
                          className={`vr-resp${count === 0 ? " vr-resp-empty" : ""}`}
                          key={index}
                          style={{ animationDelay: `${0.04 * index}s` }}
                        >
                          <span className="vr-resp-name ur">{ur(item)}</span>
                          <strong className="vr-resp-count">{count}</strong>
                        </div>
                      );
                    })}
                  </div>
                </ReportSection>
              ) : null}

              {reportData.unitResponsibilityCounts?.length !== 0 ? (
                <ReportSection
                  title={
                    <GetLanguageString props="report_vacant_responsibilities_details" />
                  }
                  hint={
                    <GetLanguageString props="report_vacant_responsibilities_bar_hint" />
                  }
                >
                  <div className="rk-scroll">
                    <table className="rk-table vr-overview">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>
                            <GetLanguageString props="quick_reports3_unit_name" />
                          </th>
                          <th className="text-center">
                            <GetLanguageString props="report_vacant_responsibilities_total" />
                          </th>
                          <th className="text-center">
                            <GetLanguageString props="report_vacant_responsibilities_vacant" />
                          </th>
                          <th className="text-center">
                            <GetLanguageString props="report_vacant_responsibilities_two_responsibles" />
                          </th>
                          <th className="text-center">
                            <GetLanguageString props="report_vacant_responsibilities_three_responsibles" />
                          </th>
                          <th className="text-center">
                            <GetLanguageString props="report_vacant_responsibilities_mubtadi_responsibles" />
                          </th>
                          {responsibilitiesList.map((item, index) => (
                            <th className="text-center ur" key={index}>
                              {ur(item)}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {reportData?.unitResponsibilityCounts?.map(
                          (record, index) => {
                            totalCount.vacantResponsibilities +=
                              record.vacantUnitResponsibilitiesCount;
                            totalCount.totalResponsibilities +=
                              record.totalUnitResponsibilitiesCount;
                            totalCount.twoResponsibles +=
                              record.twoUnitResponsibleMembersCount;
                            totalCount.threeResponsibiles +=
                              record.threeUnitResponsibleMembersCount;
                            totalCount.mubatadiResponsibiles +=
                              record.mubtadiUnitResponsibleMembersCount;
                            const vacant =
                              record.vacantUnitResponsibilitiesCount;
                            const tone =
                              vacant >= MANY_VACANT
                                ? "many"
                                : vacant > 0
                                  ? "some"
                                  : "";
                            const filledPercent =
                              record.totalUnitResponsibilitiesCount > 0
                                ? Math.round(
                                    ((record.totalUnitResponsibilitiesCount -
                                      vacant) /
                                      record.totalUnitResponsibilitiesCount) *
                                      100,
                                  )
                                : 0;
                            return (
                              <tr
                                key={index}
                                style={{
                                  animationDelay: `${Math.min(index, 12) * 0.04}s`,
                                }}
                              >
                                <td className="vr-num">{index + 1}</td>
                                <td className="ur vr-name">
                                  {ur(record.unitName)}
                                  <div className="vr-meter">
                                    <div className="vr-unit-bar">
                                      <i
                                        className={tone ? `vr-${tone}` : ""}
                                        style={{ width: `${filledPercent}%` }}
                                      />
                                    </div>
                                    <small>{filledPercent}%</small>
                                  </div>
                                </td>
                                <td className="text-center">
                                  {record.totalUnitResponsibilitiesCount}
                                </td>
                                <td className="text-center">
                                  <span
                                    className={`vr-pill${tone ? ` vr-pill-${tone}` : ""}`}
                                  >
                                    {vacant}
                                  </span>
                                </td>
                                <td className="text-center">
                                  {record.twoUnitResponsibleMembersCount}
                                </td>
                                <td className="text-center">
                                  {record.threeUnitResponsibleMembersCount}
                                </td>
                                <td className="text-center">
                                  {record.mubtadiUnitResponsibleMembersCount}
                                </td>
                                {Object.entries(
                                  record.responsibilitiesCounts,
                                ).map(([key, value], i) => (
                                  <td className="text-center" key={key}>
                                    {record.responsibilitiesCountNA[i]
                                      ? value
                                      : "N/A"}
                                  </td>
                                ))}
                              </tr>
                            );
                          },
                        )}
                        <tr className="vr-total">
                          <td></td>
                          <td></td>
                          <td className="text-center">
                            {totalCount.totalResponsibilities}
                          </td>
                          <td className="text-center">
                            {totalCount.vacantResponsibilities}
                          </td>
                          <td className="text-center">
                            {totalCount.twoResponsibles}
                          </td>
                          <td className="text-center">
                            {totalCount.threeResponsibiles}
                          </td>
                          <td className="text-center">
                            {totalCount.mubatadiResponsibiles}
                          </td>
                          {reportData?.responsibilitiesTotalCount?.map(
                            (item, index) => (
                              <td className="text-center" key={index}>
                                {reportData?.responsibilitiesTotalCountNA[index]
                                  ? item
                                  : "N/A"}
                              </td>
                            ),
                          )}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ReportSection>
              ) : (
                <NoResult />
              )}

              {searchValue.showDetails && (
                <>
                  <ReportSection
                    title={
                      <GetLanguageString props="report_vacant_responsibilities_member_two_responsibles" />
                    }
                    count={reportData?.twoResponsibilityMembers?.length}
                  >
                    <MemberTable
                      members={reportData?.twoResponsibilityMembers}
                    />
                  </ReportSection>
                  <ReportSection
                    title={
                      <GetLanguageString props="report_vacant_responsibilities_member_three_responsibles" />
                    }
                    count={reportData?.threeResponsibilityMembers?.length}
                  >
                    <MemberTable
                      members={reportData?.threeResponsibilityMembers}
                    />
                  </ReportSection>
                  <ReportSection
                    title={
                      <GetLanguageString props="report_vacant_responsibilities_member_mubtadi_responsibles" />
                    }
                    count={reportData?.mubtadiResponsibilityMembers?.length}
                  >
                    <MemberTable
                      members={reportData?.mubtadiResponsibilityMembers}
                      showNote
                    />
                  </ReportSection>
                </>
              )}
            </div>
          ) : null
        ) : (
          LoadingSpinner()
        )}
      </div>
    </div>
  );
};

export default VacantResponsibilitiesReport;
